import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
import { errorFieldTypeTab } from "../../i18n";
/* export * from "./authentication"; */

export const postPerson = personData => {
  return dispatch => {
    dispatch({ type: "POST_PERSON_LOADING" });
    api
      .personPost(personData)
      .then(resp => {
        if (personData.personId) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        if (e.response.data && e.response.data.localizedMessages) {
          dispatch(buildAlertWithLocalizedMessages(
            "ERROR",
            "AddPersonErrorAlertTitle",
            "Virhe henkilön tallennuksessa",
            e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
        } else {
          const errorMap = [
            { // Procountor: {insurancesConfiguration.accidentInsurance.occupationalTitleId=MISSING_OCCUPATIONAL_TITLE}
              regex: /MISSING_OCCUPATIONAL_TITLE/,
              field: "OccupationCodeTK10",
              type: "isMissing",
              tab: "EmploymentInfo",
            },
            { // Procountor: {paymentInfo.accountNumber=INVALID_PERSON_EMPLOYEE_DATA}
              regex: /accountNumber=INVALID_PERSON_EMPLOYEE_DATA/,
              field: "Iban",
              type: "isMissing",
              tab: "PersonalDetails",
            },
            { // Procountor: {incomeConfiguration.salaryChannel=NOT_ALLOWED_SALARY_CHANNEL}
              regex: /NOT_ALLOWED_SALARY_CHANNEL/,
              field: "PayslipMethod",
              type: "isNotAllowed",
              tab: "PersonalDetails",
            },
            { // Procountor: {invoicingInfo.identifierType=INVALID_PERSON_EMPLOYEE_DATA, invoicingInfo.identifier=ERROR_BRN_CODE}
              regex: /identifierType=INVALID_PERSON_EMPLOYEE_DATA/,
              field: "IdentifierCodeType",
              type: "isInvalid",
              tab: "PersonalDetails",
            },
            { // Procountor: {invoicingInfo.identifier=ERROR_BRN_CODE}
              regex: /ERROR_BRN_CODE/,
              field: "SocSec",
              type: "isInvalid",
              tab: "PersonalDetails",
            },
            { // Procountor: {incomeConfiguration.baseSalaryValue=MUST_NOT_BE_NULL}
              regex: /baseSalaryValue=MUST_NOT_BE_NULL/,
              field: "PayAmount",
              type: "isMissing",
              tab: "SalaryInformation",
            },
          ];

          let { message } = e.response.data;

          const matched = errorMap.find((entry) => entry.regex.test(message));

          if (matched) { // {{Iban}} {{isMissing}} on the {{PersonalDetails}} tab
            message = errorFieldTypeTab(matched.field, matched.type, matched.tab); // {{field}} {{type}} on the {{tab}} tab
          }

          dispatch({
            type: "ALERT",
            payload: {
              type: "ERROR",
              titleKey: "AddPersonErrorAlertTitle",
              titleDefault: "Virhe henkilön tallennuksessa",
              message,
              localizedMessages: e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null,
            },
          });
        }
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_PERSON_SUCCEEDED",
  payload: { person: data },
});

const postEditSucceeded = data => ({
  type: "POST_PERSON_EDIT_SUCCEEDED",
  payload: { person: data },
});

const operationFail = () => ({
  type: "POST_PERSON_FAIL"
});
